import { gql } from '@apollo/client';

export const GET_PATIENT_DETAILS = gql`
  query GetPatientDetails(
    $patientId: MongoID!
    $technology: EnumExamTechnology!
  ) {
    patient(filter: { _id: $patientId }) {
      firstName
      lastName
      _id
      birthDate
      identificationType
      identificationNumber
      phone
      email
      country
      sex
      ethnicity
    }
    allExamCount: examCount(filter: { patient: $patientId })
    examCount(filter: { patient: $patientId, technology: $technology })
  }
`;

export const UPDATE_PATIENT_DETAILS = gql`
  mutation UpdatePatientDetails(
    $updatePatientId: MongoID!
    $updatePatientRecord: UpdateOnePatientInput!
  ) {
    updatePatient(
      filter: { _id: $updatePatientId }
      record: $updatePatientRecord
    ) {
      record {
        _id
        firstName
        lastName
        birthDate
        identificationType
        identificationNumber
        phone
        country
        email
        sex
        ethnicity
      }
    }
  }
`;

export const REMOVE_PATIENT = gql`
  mutation removePatientById($removePatientId: MongoID!) {
    removePatientById(id: $removePatientId)
  }
`;

export const COUNT_PATIENT_EXAMS = gql`
  query examCount($filter: FilterCountExamInput!) {
    examCount(filter: $filter)
  }
`;
